__turbopack_context__.v({
  "className": "inter_28bf4bbb-module__-p914W__className",
});
